import { type App, inject } from 'vue'

export type ServerStatusState = {
    readonly status: number | undefined
    setStatus(status: number): void
}

const key = `app.plugin.status`

export function installStatusPlugin(
    app: App,
    statusState: ServerStatusState
): ServerStatusState {
    app.provide(key, statusState)

    return statusState
}

export function createServerStatusState(): ServerStatusState {
    let status: number | undefined = undefined

    const setStatus = (s: number) => {
        status = s
    }

    return {
        get status(): number | undefined {
            return status
        },
        setStatus,
    }
}

export function useSetStatus(): ServerStatusState {
    return inject(key) as ServerStatusState
}
